const FiltrosApi = {
    set: function (data) {
        sessionStorage.removeItem('filtros');
        sessionStorage.setItem('filtros', JSON.stringify(data));
    },
    get: function () {
        const data = sessionStorage.getItem('filtros');
        return JSON.parse(data);
    },
};

export default FiltrosApi